export const getMachineId = () => {
  const key = "machineId"

  let machineId = localStorage.getItem(key)

  if (machineId) {
    return machineId
  }

  if (window.crypto && window.crypto.randomUUID) {
    machineId = window.crypto.randomUUID()
  } else {
    machineId = `web-${Date.now()}-${Math.random().toString(16).slice(2)}`
  }

  localStorage.setItem(key, machineId)

  return machineId
}